import React, { Fragment, useEffect } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { H2, H6 } from "../../../../AbstractElements";
import CountUp from "react-countup";
import {
  ProductsSvg,
  MessagesSvg,
  NewUserSvg,
  EarningsSvg,
} from "../../../../Data/Widgets/General/Data";

const ProStaticWidgets = (props) => {
  const personalDetails = props.details;
 
  const WidgetData = [
    {
      id: 1,
      title: "Customers",
      counter: Number(personalDetails?.active_customers || 0),
      prefix: "",
      svg: <NewUserSvg />,
      class: "progress-gradient-danger",
      progress: "48%",
    },
    {
      id: 2,
      title: "Connection",
      counter: Number(personalDetails?.active_connections || 0),
      prefix: "",
      svg: <ProductsSvg />,
      class: "progress-gradient-success",
      progress: "60%",
    },
    {
      id: 3,
      title: "Unpaid",
      counter:Number(personalDetails?.unpaid_amount || 0),
      prefix: "₹ ",
      svg: <MessagesSvg />,
      class: "progress-gradient-primary",
      progress: "48%",
    },
    {
      id: 4,
      title: "Paid Amount",
      counter: Number((personalDetails?.paid_amount || 0)),
      prefix: "₹ ",
      svg: <EarningsSvg />,
      class: "progress-gradient-secondary",
      progress: "75%",
    },
    {
      id: 5,
      title: "Credit Balance",
      counter: Number(
        (personalDetails?.credit_balance || 0),
      ),
      prefix: "₹ ",
      svg: <EarningsSvg />,
      class: "progress-gradient-warning",
      progress: "65%",
    },
    {
      id: 6,
      title: "Message Usage",
      counter: Number(
        (personalDetails?.msg_usage || 0),
      ),
      prefix: "",
      svg: <MessagesSvg />,
      class: "progress-gradient-info",
      progress: "55%",
    },
  ];

  return (
    <Fragment>
      {WidgetData.map((data) => (
        <Col sm="6" lg="4" key={data.id}>
          <Card className="o-hidden h-95" style={{ minHeight: "15px" }}>
            <CardBody>
              <div className="d-flex static-widget">
                <div className="flex-grow-1">
                  <H6 className="font-roboto"
                  style={{ fontSize: "10px", fontWeight: "500", color: "#666", minHeight: "32px", lineHeight: "20px", }}>{data.title}</H6>
                  <H2 attrH2={{ className: "mb-0 counter" ,style: { fontSize: "13px", fontWeight: "700", color: "#222", wordBreak: "break-word", }, }}>
                    <CountUp
                      prefix={data.prefix}
                      end={data.counter}
                      duration={0.8}
                      decimals={2}
                    />
                  </H2>
                </div>
                {data.svg}
              </div>

              <div className="progress-widget">
                <div className="progress sm-progress-bar progress-animate">
                  <div
                    className={data.class}
                    role="progressbar"
                    style={{ width: data.progress }}
                  >
                    <span className="animate-circle"></span>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Fragment>
  );
};

export default ProStaticWidgets;

